export default __webpack_public_path__ + "menu-orders-smop-icon.910bc505e4bbf3b1388d571152444031.svg";